// css
import "../../style/lottery/lottery_info.scss";

import React, {useEffect, useState} from "react";
import {useLoading} from "../components/loading/LoadingProvider.tsx";
import Layout from "../layout/Layout.tsx";
import {post} from "../utils/FetchUtil.ts";
import parse from 'html-react-parser';

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
//import "swiper/css";
//import "swiper/css/navigation";

import {imgs} from "../utils/ImageUtil.ts";
import {Button, FormCheck, Image} from "react-bootstrap";
import {useParams} from "react-router-dom";
import {replaceTo, url} from "../utils/UrlsUtil.ts";
import {toast} from "react-toastify";
import {isEmpty, isNotEmpty} from "../utils/CommonUtil.ts";


const LotteryIntroPage:React.FC = () => {
    const breadcrumbList = ["くじギフトの紹介"];
    const { showLoading, hideLoading } = useLoading();
    const [errorList, setErrorList] = useState([]);
    const [lottery, setLottery] = useState<LotteryIntronDto>();
    const {order_number_enc} = useParams();

    const [isConsent, setIsConsent] = useState(true);

    const [ email, setEmail ] = useState("");
    const [ password, setPassword ] = useState("");
    const [loggedin, setLoggedin] = useState(false);
    const [registered, setRegistered] = useState(false);


    /** くじ紹介ページ情報の取得 */
    const fetchPageInfo = () => {
        showLoading();
        post<LotteryIntronDto>({
            action: "/api/lottery/fetchIntro",
            data: {order_number_enc: order_number_enc},
        })
            .then((data) => {
                setLottery(data);
                console.log(data);
                if(data !== undefined) {
                    setLoggedin(data.loggedin);
                    setRegistered(data.registered);
                    setEmail(data.email);
                }
            })
            .catch((reason) => {
                console.log(reason);
                toast.error(reason);
            })
            .finally(() => {
                hideLoading();
            });
    };

    /** 抽選の開始処理 */
    const proceedRaffle = () => {
        if(!isConsent) {
            toast.error("利用規約の同意が必要です。「利用規約に同意する」にチェックしてください。");
            return false;
        }
        showLoading();
        post<LotteryStartDto>({
            action: "/api/lottery/prepareRaffle",
            data: {order_number_enc: order_number_enc},
        })
            .then((result) => {
                console.log(result?.raffle_url);
                replaceTo(result?.raffle_url);
            })
            .catch((reason) => {
                console.log(reason);
                // @ts-ignore
                setErrorList([reason]);
            })
            .finally(() => {
                hideLoading();
            });

    };

    /** ログイン */
    const loginGeevaAccount = () => {
        let errorMessages = "";
        if(isEmpty(email)) {
            errorMessages = errorMessages + "ログインIDを入力してください\n";
        }

        if(isEmpty(password)) {
            errorMessages = errorMessages + "パスワードを入力してください";
        }

        if(isNotEmpty(errorMessages)) {
            toast.error(errorMessages);
            return false;
        }

        showLoading();
        post<LoginLotteryDto>({
            action: "/api/login/lottery/auth",
            data: {login_id: email, password: password},
        })
            .then((result) => {
                if(result !== undefined) {
                    setLoggedin(result.loggedin);
                    setRegistered(result.registered);
                }
            })
            .catch((reason) => {
                console.log(reason);
                // @ts-ignore
                setErrorList([reason]);
            })
            .finally(() => {
                hideLoading();
            });

    };

    useEffect(() => {
        fetchPageInfo();
    }, []);
    return (
        // ---------------------------
        // くじの紹介ページ
        // ---------------------------
        <Layout breadcrumb_list={breadcrumbList} error_list={errorList}>
            <div className="row gx-0 lottery-intro page-content">
                <div className="col-12">
                    <div className="main-head item-index_head">
                        <div className="mb-3">
                            <Image src={url("/images/lottery/geeva_lottery.jpg")} fluid={true}/>
                        </div>
                        <h1 className="txt-size24 mb-3 title-main">抽選で賞品が当るgeevaくじ</h1>
                    </div>
                    <div className="desc">
                        geevaのオンラインギフトをご注文するか<br/>
                        ギフトをもらった方は<br/>
                        geeva会員になると、抽選で賞品が当ります！
                    </div>
                </div>
                <div className="col-12 lottery-gallery">

                    {/*  賞品一覧スライド */}
                    <Swiper
                        modules={[Navigation]}
                        navigation
                        spaceBetween={0}
                        slidesPerView={2}
                        className={"swiper-main my-4"}
                        breakpoints={{
                            // when window width is >= 1024px
                            1024: {
                                width: 1024,
                                slidesPerView: 4,
                            },
                        }}
                    >
                        {lottery?.lottery_prize_list.map((prize) =>
                            <SwiperSlide>
                                <div className="prize-item">
                                    {/*  抽選タイトル */}
                                    <div className="lottery-title">
                                        <div className="lottery-title-inner">
                                            {prize.lottery_title}
                                        </div>
                                    </div>
                                    {/*  抽選期間 */}
                                    <div className="lottery-period">抽選期間：{prize.period}</div>
                                    {/*  賞品画像 */}
                                    <div className="prize-image">
                                        <Image src={imgs(prize.prize_image, 400, 400)} fluid={true} ></Image>
                                    </div>
                                    {/*  賞品タイトル */}
                                    <div className="prize-title">{parse(prize.prize_title)}</div>
                                </div>
                            </SwiperSlide>
                        )}
                    </Swiper>
                </div>
                {/*  geeva会員未登録の人たち向け（ */}
                {(!registered && !loggedin) &&
                  <>
                    <div className="col-12">
                        <div>
                            利用規約に同意し「抽選に進む」と<br/>
                            会員登録と抽選が始まります。
                        </div>
                        <div>
                            <FormCheck
                                inline
                                label="利用規約に同意する"
                                name="consentTerms"
                                type="checkbox"
                                checked={isConsent}
                                onChange={(e) =>
                                    setIsConsent(e.target.checked)}
                            />
                        </div>
                    </div>
                    <div className="col-12 mt-5">
                      <div className="main-buttons">
                        <Button variant="primary" className="btn-raffle w-100"
                                onClick={() => proceedRaffle()}>抽選に進む</Button>
                      </div>
                    </div>
                  </>
                }
                {/*  geeva会員登録済み＆未ログインの人はログインフォームを表示する */}
                {(registered && !loggedin) &&
                  <div className="col-12">
                    <div className={"login-desc mt-3 mb-3"}>
                      geeva会員でログインすると抽選へ進むことが出来ます。
                    </div>
                    <form className={"login-form"}>
                      <div className={"row"}>
                        <label className={"col-12"} htmlFor={"login_id"}>ログインID</label>
                        <input type="text"
                               id={"login_id"}
                               className="form-control col-12"
                               value={email}
                               onChange={(e) => {
                                   setEmail(e.target.value);
                               }}
                               placeholder="ログインID（メール）"
                        />
                      </div>
                      <div className={"row mt-2"}>
                        <label className={"col-12"} htmlFor={"password"}>パスワード</label>
                        <input type="password"
                               id={"password"}
                               className="form-control col-12"
                               value={password}
                               onChange={(e) => {
                                   setPassword(e.target.value);
                               }}
                               placeholder="パスワード"
                        />
                        <div className={"col-12 mt-4 mb-3"}>
                          <div className="main-buttons">
                            <Button variant="primary"
                                    className="btn-login btn-sm w-100"
                                    onClick={() => loginGeevaAccount()}>ログイン</Button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                }
                {(registered && loggedin) &&
                  <div className="col-12 mt-5">
                    <div className="main-buttons">
                      <Button variant="primary"
                              className="btn-raffle w-100"
                              onClick={() => proceedRaffle()}>抽選に進む</Button>
                    </div>
                  </div>
                }
                <div className="col-12 lottery-footer">
                    <div className="lottery-footer-inner">
                        <div className="row footer-item gx-2">
                            <div className="col-12 footer-title1">eギフト専門のｇｅｅｖａ</div>
                            <div className="col-5">
                                <Image src={url("/images/lottery/geeva_logo.jpg")} fluid={true} />
                            </div>
                            <div className="col-7">
                                <div className="footer-desc1">
                                    geevaは２万点以上の商品を４０万名以上にお届けしているeギフト専門に販売しています。<br/>
                                    有名ブランドや拘りの生産者などの産直品まで幅広い商品をeギフトとして提供しております。
                                </div>
                                <div>
                                    <a href="https://www.geeva.co.jp/">https://www.geeva.co.jp/</a>
                                </div>
                            </div>
                        </div>
                        <div className="site-title">運営ECサイト</div>
                        <div className="row footer-item">
                            <div className="col-12 footer-title2">引出物専門ECサイト hikica++（ヒキカ）</div>
                            <div className="col-4">
                                <Image src={url("/images/lottery/hikica_logo.jpg")} fluid={true} />
                            </div>
                            <div className="col-8">
                                <div className="footer-desc2">
                                    ３品選べる引出物カードをｇｅｅｖａが初めて開発し販売を開始ししました。毎年５，０００組以上の新郎新婦の引き出物としてご愛顧いただいております。
                                </div>
                                <div>
                                    <a href="https://www.geeva.co.jp/">https://www.geeva.co.jp/</a>
                                </div>
                            </div>
                        </div>
                        <div className="row footer-item">
                            <div className="col-12 footer-title2">法人専門オンラインギフトECサイト　b<span>i</span>zGeeva（ビズギーバ）</div>
                            <div className="col-4">
                                <Image src={url("/images/lottery/bizgeeva_logo.jpg")} fluid={true} />
                            </div>
                            <div className="col-8">
                                <div className="footer-desc2">
                                    福利厚生や販促などの法人利用に特化したECサイトです。eギフトならではの扱いやすさと多様なギフトのラインナップが大変人気です。<br/>
                                    熨斗包装にもフォーマルなご利用にも対応しています。
                                </div>
                                <div>
                                    <a href="https://bizgeeva.jp/">https://bizgeeva.jp/</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
export default LotteryIntroPage;